import useSWR from 'swr'

import { FetchError } from '../../../../data/fetchError'
import { FetchResponse } from '../../../../data/fetchResponse'
import { FetchResult } from '../../../../data/fetchResult'
import { fetchJson } from '../../../../data/fetchers'
import { useConfigContext } from '../../../ui-config'
import { EInvoiceHistory } from './model'

export function useEInvoiceHistory(): FetchResult<EInvoiceHistory[]> {
  const { pollingConfig } = useConfigContext()
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<EInvoiceHistory[]>,
    FetchError
  >('/history/einvoices', fetchJson<EInvoiceHistory[]>, {
    refreshInterval: pollingConfig.intervalInSeconds * 1000,
  })

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
